/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Validator } from '@squiz/dxp-console-support';

/**
 * Validates a path URL.
 */
export class PathURLValidator<R> extends Validator<unknown, R> {
  public doValidate(value: unknown): boolean {
    return value ? String(value).startsWith('/') : true;
  }
}
